/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, { useEffect, useState, useCallback, useContext } from 'react'
import ReactModal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import HeaderContext from '../../Components/Context/HeaderContext';
import { CartPayload } from '../../redux/helper/CartPayloadGenerator';
import { distributorService } from '../../service/distributor.service';
import ClearCart from './ClearCart';

export default function AllOfferProgress({ ViewOffer, cartProducts, cartList, selectedCriteria, ViewData, specialCartList, isEligible, specialRecurring, subsequentOrder,
    prodItem, offerParameter, criteriaMainObject, mainObj,
    offerData }) {
    const navigate = useNavigate();
    const {
        SetSuccessMessage,
        setcolorValue,
        SetErrorMessage,
    } = useContext(HeaderContext);
    const { items } = ViewOffer;
    const [removePopup, setremovePopup] = useState('');
    const [removeLoader, setremoveLoader] = useState(false);
    useEffect(() => {
        handlequantity()

    }, [specialCartList])

    const handleSuccessMessage = (name) => {

        SetSuccessMessage(name);

        setTimeout(() => {
            SetSuccessMessage('');
            setModalOpen('');
            setcolorValue(false);
            if (diff) {
                setModalOpen('popup')
            }
        }, 1000)
    }
    const handleTotalValue = useCallback(
        (key) => {
            const List = Object.values(specialCartList) || [];
            let totalCount = 0;
            List.map((item) => {
                if (key === 'quantity') {
                    totalCount += Number(item.quantity)
                } else {
                    totalCount += Number(item.LIST_PRICE) * Number(item.quantity)

                }
            })
            return totalCount;
        },
        [specialCartList],
    )
    const handleCalculation = useCallback(
        (key) => {
            const List = prodItem;
            let totalCount = 0;
            Object.keys(List).length > 0 && Object.keys(List).map((item) => {
                totalCount += parseFloat(List[item][key] || 0)
            })
            return totalCount;
        },
        [specialCartList],
    )



    // const CriteriaMeetCheck=(item,i)=>{
    //     let status=false
    //     if(offerData.items){
    //         if(item.OFFER_PARAMETER==='quantity'){
    //             const count =GetCartCount(i,'total')
    //             status=count >=Number(item.MIN_QUANTITY) && count <=Number(item.MAX_QUANTITY)
    //         }else{
    //             const valCount=Object.keys(offerData?.items)?.length>0?offerData?.items[item.id]?.orderValue:0
    //             status=valCount>=Number(item.MIN_VALUE) && valCount <=Number(item.MAX_VALUE)
    //         }
    //     }
    //     return status
    // }
    const handleAddBulkProducts = async (key) => {
        let exist = false;
        if (key === undefined) {
            const cartItems = await distributorService.CartItems();
            if (!cartItems.error && cartItems.data.data.cart_items.length > 0) {
                exist = true;
                setremovePopup('active')

            } else {
                exist = false
            }
        }
        const payload = Object.values(specialCartList);
        if (exist === false) {
            for (let index = 0; index < payload.length; index++) {
                payload[index]['split_address'] = ViewOffer.items.split_shipping === true;
                payload[index]['dap_config'] = ViewOffer.items.dap_config === false ? false : true;
            }
            distributorService.BulkAddFromOffer(payload).then((res) => {
                if (!res.error && res.data.success_status) {
                    handleSuccessMessage(res.data.message)
                    localStorage.setItem('FromOffer', '1')
                    // delete item from local cart
                    if (items.offer_type === 'Standard') {
                        distributorService.clearCart('key').then((result) => {
                            navigate('/cart');
                        })
                    } else {
                        navigate('/cart');
                    }
                }
            })
            offerData?.products
        }

    }
    const handleClearCart = async () => {
        const cart = await distributorService.clearCart();
        if (!cart.error && cart.data.success_status) {
            cartList();
            setremovePopup('');
            handleAddBulkProducts('key')

        }

    }

    function countDiscountsAboveZero(dataObject) {
        let discountedCriteria = Object.values(dataObject).filter(entry => entry.discount > 0).length;
        return discountedCriteria;
    }

    //checking sum
    const handleFinalCheck = () => {
        const CheckingArray = Object.keys(prodItem).length > 0 && Object.values(prodItem).filter((item => item.and_combination)) || [];

        //for special recurring
        const allConditionSatisfiedArray =
            Object.keys(prodItem).length > 0
                ? Object.values(prodItem).filter(item => item.condition_satisfied === true)
                : [];
        let parameter = 'cumulative_' + ViewOffer?.offer_parameter
        if (specialRecurring && !mainObj?.subsequent_order) {
            //directly checking the lengths of and condition and condition_satisfied  items
            return CheckingArray.length !== allConditionSatisfiedArray.length;
        } else if (specialRecurring && mainObj?.subsequent_order) {
            if (mainObj?.offer_parameter === 'quantity') {
                return (
                    mainObj?.total_current_quantity < ViewOffer?.items?.minimum_cap ||
                    mainObj?.total_cumulative_quantity > ViewOffer?.items?.maximum_cap ||
                    CheckingArray.length > countDiscountsAboveZero(prodItem)
                );
            } else {
                return (
                    mainObj?.total_current_value < ViewOffer?.items?.minimum_cap ||
                    mainObj?.total_cumulative_value > ViewOffer?.items?.maximum_cap ||
                    CheckingArray.length > countDiscountsAboveZero(prodItem)
                );
            }
        } else {
            if (ViewOffer?.items?.offer_type === "Standard") {
                const CheckingArray = Object.keys(prodItem).length > 0 && Object.values(prodItem).filter((item => item.condition_satisfied)) || [];
                return CheckingArray.length === 0
            } else {
                const CheckingArray = Object.keys(prodItem).length > 0 && Object.values(prodItem).filter((item => item.and_combination)) || [];
                let IsOk = [];
                CheckingArray.map((val) => {
                    if (!val.condition_satisfied) {
                        IsOk.push(false)
                    }
                })
                return IsOk.length !== 0
            }
            // return CheckingArray.length !== allConditionSatisfiedArray.length;
        }
    }
    const PackageandSizeMatchError = () => {
        const arr = ViewData.items || [];
        let CheckArr = [];
        Object.keys(arr).map((val) => {
            if (arr[val].CheckError) {
                CheckArr.push('exist')
            }
        })
        return CheckArr;

    }
    const [quantityObj, setquantityObj] = useState({})
    const handlequantity = useCallback(
        () => {
            const copy = {};
            Object.keys(specialCartList).map((val) => {
                if (copy[specialCartList[val].PRIMARY_UOM_CODE]) {
                    copy[specialCartList[val].PRIMARY_UOM_CODE] += parseFloat(specialCartList[val].quantity)
                } else {
                    copy[specialCartList[val].PRIMARY_UOM_CODE] = parseFloat(specialCartList[val].quantity)
                }
            })
            return copy
        },
        [specialCartList],
    )
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
        },
    };

    return (
        <div className="lg:min-w-[330px] min-w-full h-auto bg-[#E9EDF4] rounded-lg lg:ml-[18px] ml-0 mb-2.5 lg:mt-0 mt-3 p-4 progress">
            <ReactModal style={customStyles} isOpen={removePopup !== ''}>
                <ClearCart
                    // RemoveFromCart={RemoveFromCart}
                    setremovePopup={setremovePopup}
                    handleClearCart={handleClearCart}
                    handleAddBulkProducts={handleAddBulkProducts}
                    loading={removeLoader}
                    setremoveLoader={setremoveLoader} />
            </ReactModal>
            {/* <p className="text-[#090406] text-sm font-semibold">Progress</p> */}
            {/* {Object.keys(prodItem).map((criteria,i)=>(
                <div className="px-1 mt-4" key={i}>
                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox4 flex items-center">
                        <input type="checkbox" id="checkbox-1" checked={prodItem[criteria].condition_satisfied}/>
                        <label htmlFor="checkbox-1" className={`text-sm font-bold ${prodItem[criteria].and_combination?
                            prodItem[criteria].condition_satisfied?'text-[#555259]':'text-[#A5A5A5]':'text-[#A5A5A5]'} pl-2 cursor-pointer`}>Offer Criteria {i+1} <span className="text-[#555259] font-normal text-xs3 pl-3">Total Order Qty.: <span className="text-[#555259] font-semibold text-xs3 ">{prodItem[criteria].quantity} kg</span></span></label>
                    </div>
                </div>
            ))} */}
            {/* <div className="px-1 mt-3">
                <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox4 flex items-center">
                    <input type="checkbox" id="checkbox-3" />
                    <label htmlFor="checkbox-3" className="text-sm font-bold text-[#A5A5A5] pl-2 cursor-pointer">Offer Criteria 2 <span className="text-[#A5A5A5] font-normal text-xs3 pl-3">Total Order Qty.: <span className="text-[#A5A5A5] font-semibold text-xs3 ">0 kg</span></span></label>
                </div>
            </div> */}
            {/* <p className="text-xs3 font-normal text-[#555259] " style={{maxWidth:'500px',flexWrap:'wrap'}}>Total Order Qty.: 
                {Object.keys(specialCartList).length>0 && Object.keys(specialCartList)?.map((UOM,i)=>(
                    <span style={{float: `${i===0?'':'right'}`}} key={UOM} className={`font-semibold`}>{Number(specialCartList[UOM]?.quantity)||0} {specialCartList[UOM]?.PRIMARY_UOM_CODE} <br/></span>
                ))}</p> */}
            <div className="flex justify-between mt-3 pt-3">
                <p className="font-normal text-sm text-[#000000]">Total Order Quantity</p>
                <p className="tex-[#000000] font-semibold text-sm">{Object.keys(handlequantity()).length > 0 && Object.keys(handlequantity())?.map((UOM, i) => (
                    <span style={{ float: `${i === 0 ? '' : 'right'}`, flexWrap: 'wrap', maxWidth: '100px' }} key={UOM} className={`font-semibold`}>{Number(handlequantity()[UOM]) || 0} {UOM}<br /></span>
                ))}</p>
            </div>
            <div className="flex justify-between mt-3 pt-3">
                <p className="font-normal text-sm text-[#000000]">Net Order Quantity</p>
                <p className="tex-[#000000] font-semibold text-xs7">{handleTotalValue('quantity')}</p>
            </div>
            <div className="flex justify-between mt-3">
                <p className="font-normal text-sm text-[#000000]">Total Order Value</p>
                <p className="tex-[#000000] font-semibold text-xs7">{handleTotalValue('total').toLocaleString('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                })}</p>
            </div>
            <div className="flex justify-between mt-3">
                <p className="font-normal text-sm text-[#000000]">Total Discount</p>
                <p className="tex-[#000000] font-semibold text-xs7">{handleCalculation('discount').toLocaleString('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                })}</p>
            </div>
            <div className="flex justify-between mt-3">
                <p className="font-normal text-sm text-[#000000]">Total Net Amount</p>
                <p className="tex-[#000000] font-semibold text-xs7">{Number(handleTotalValue('total') - handleCalculation('discount')).toLocaleString('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                })}</p>
            </div>

            {/* <div className="flex justify-between items-center mt-2">
                <p className="text-xs5 font-bold text-[#555259]">Total Net Amount</p>
                <p className="font-bold text-base text-[#555259]">{Number(OrderValue-handleDiscount()).toLocaleString('en-IN', {
                    style: 'currency',
                    currency: 'INR',
                })}</p>
            </div> */}
            <button
                onClick={() => handleAddBulkProducts()}
                type="button"
                disabled={handleFinalCheck() || parseFloat(handleTotalValue('quantity')) === 0 || !(isEligible?.is_eligible)}
                className={`w-full ${handleFinalCheck() || parseFloat(handleTotalValue('quantity')) === 0 || !(isEligible?.is_eligible) ? 'bg-[#A5A5A5]' : 'bg-[#555259]'} rounded-[8px] text-[#FFFFFF] text-sm font-semibold py-3 mt-2`}
                data-bs-toggle="modal"
                data-bs-target="#addtocart">
                Add all products to Cart
            </button>
        </div>
    )
}
